import { Component, OnInit, ElementRef, ViewChild, EventEmitter, Output, Input, HostListener, Renderer2 } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SiteStettingService } from 'src/app/core/services/site-stetting.service';
import { Location } from '@angular/common';
import { AppMessagesService } from 'src/app/core/services/app-messages.service';
import { AppConfigService } from 'src/app/core/services/app-config.service';
import { InMemoryService } from 'src/app/shared/in-memory-web-api/in-memory.service';
import { Router } from '@angular/router';
import { AppServiceService } from 'src/app/core/services/app-service.service';

@Component({
  selector: 'app-login-via-password-moe',
  templateUrl: './login-via-password-moe.component.html',
  styleUrls: ['./login-via-password-moe.component.scss']
})
export class LoginViaPasswordMoeComponent implements OnInit {
  passWordForm: FormGroup;
  showPopupCard: boolean = false;
  @Input() capsOn = "";
  @Input() hebrewCharater = "";
  message:string = "";
  sitekey: string;
  CaptchaNeeded:boolean;
  resetPassword:string;
  links:any;
  service:any;
  loader:boolean = false;
  isValidFormSubmitted:boolean = false;
  mobile:string;
  windowRef: any = window;
  constructor(
    private formBuilder: FormBuilder,private appConfigService:AppConfigService ,
    private _siteSettingService: SiteStettingService ,private appService :AppServiceService,
     private appMessagesService :AppMessagesService , private router : Router,private el: ElementRef, private renderer: Renderer2) { }
    
  get userName() {
    return this.passWordForm.controls.userName;
  }
  get password() {
    return this.passWordForm.controls.password;
  }



  ngOnInit(): void {  
    this.service = this.appConfigService.service;
    this.appService.componentName = 'login-via-password-moe-component';
    if(this.appMessagesService.errorCode!=""){
      this.message = this.appMessagesService.returnErrorMessage(this.appMessagesService.errorCode.toString()); 
      this.appMessagesService.errorCode="";
    }
 
    this.appConfigService.getLinks().subscribe(
      (data) => {
        this.links = data;
      },
      (error)=>{
        //TODO
      })
    this.resetPassword =this.links.resetPasswordMoe;
    this.sitekey = window['_siteSettings'].recaptchaSiteKey;
    this.service.restartLogin().subscribe(data => {
      if (data)
      this.CaptchaNeeded =this._siteSettingService.CaptchaNeeded = data.isCaptchaNeeded;
    }, err => {
    });
    this.passWordForm = this.formBuilder.group({
      userName: new FormControl('', { validators: [Validators.required] }),
      password: new FormControl('', { validators: [Validators.required] }),
    });
    
    this.passWordForm.valueChanges.subscribe(value => {
      const userNameValue = value['userName'];
      const passwordValue = value['password']
      this.appService.setFieldStatus(userNameValue?.trim().length > 0 || passwordValue?.trim().length > 0);
    });
  }



  onSubmit(captchaResponse?: any) {
    this.isValidFormSubmitted = true;
    if (this.passWordForm.invalid) {
      grecaptcha.reset();
      document.getElementById("userName").focus();
       return;
    }
    this.loader = true;
    if(captchaResponse == undefined)
    {
    captchaResponse = " ";
    }
    this.service.loginWithIdAndPassword(this.passWordForm.value.userName, this.passWordForm.value.password , captchaResponse).subscribe(
      (data) => {
        this.CaptchaNeeded =this._siteSettingService.CaptchaNeeded = data.isCaptchaNeeded;
        if (data.isError == false) {
          if(data.isPasswordExpiring == true) {
          window['_target'] = this.links.resetPassword;
          this.loader = false;
          }
          else {
            this.appService.mobileOtp = data.otpDestMasked;
            this.appService.setFieldStatus(false);
            this.router.navigate(['loginOtpMoe'], { skipLocationChange: true });
          }
        }
        else 
        {
          this.message = this.appMessagesService.returnErrorMessage(data.errorCode);  
          this.passWordForm.reset();
          this.isValidFormSubmitted=false;
          document.getElementById("userName").focus();
          this.hebrewCharater="";
          grecaptcha.reset();
          this.loader = false;    
        }
     
      },
      err => {

      }) 
  }

  clearCursor(type: string) {
   if(this.isValidFormSubmitted == false && this.passWordForm.controls[type].value=='' ){
    this.passWordForm.controls[type].reset();
   }
    }
    
    clearDirective(){
      this.hebrewCharater="";
    }
  
  openPopup() {
    this.showPopupCard = true;
  }
  closePopup() {
    this.showPopupCard = false;
  }

  resetMassage(){
    this.message = "";
  }
}
